//#region components/box/box_constants.js
var e = [
	"div",
	"span",
	"section",
	"article",
	"aside",
	"main",
	"header",
	"footer",
	"nav",
	"ul",
	"ol",
	"li",
	"fieldset",
	"form",
	"figure"
], t = [
	"0",
	"1",
	"25",
	"50",
	"75",
	"100",
	"125",
	"150",
	"175",
	"200",
	"250",
	"300",
	"350",
	"400",
	"450",
	"500",
	"525",
	"550",
	"600",
	"650",
	"700",
	"750",
	"800"
], n = /* @__PURE__ */ "primary.secondary.moderate.bold.strong.contrast.backdrop.brand.info.positive.warning.critical.brand-subtle.brand-strong.info-subtle.info-strong.positive-subtle.positive-strong.warning-subtle.warning-strong.critical-subtle.critical-strong.primary-opaque.secondary-opaque.moderate-opaque.bold-opaque.strong-opaque.contrast-opaque.brand-opaque.brand-subtle-opaque.info-opaque.info-subtle-opaque.positive-opaque.positive-subtle-opaque.warning-opaque.warning-subtle-opaque.critical-opaque.critical-subtle-opaque".split("."), r = [
	"transparent",
	"subtle",
	"default",
	"moderate",
	"bold",
	"accent",
	"focus",
	"brand",
	"positive",
	"warning",
	"critical",
	"info",
	"brand-subtle",
	"brand-strong",
	"positive-subtle",
	"positive-strong",
	"warning-subtle",
	"warning-strong",
	"critical-subtle",
	"critical-strong",
	"info-subtle",
	"info-strong"
], i = [
	"0",
	"50",
	"100",
	"150",
	"200",
	"300",
	"400"
], a = [
	"0",
	"100",
	"200",
	"300",
	"350",
	"400",
	"450",
	"500",
	"550",
	"600",
	"pill",
	"circle"
], o = [
	"small",
	"medium",
	"large",
	"extra-large",
	"card"
], s = /* @__PURE__ */ "0.1px.2px.8px.25.20px.24px.50.75.100.200.300.400.500.600.700.800.900.1000.1100.1200.1300.1400.1500.1600.10p.20p.25p.30p.33p.40p.50p.60p.66p.70p.75p.80p.90p.95p.100p".split("."), c = [
	"hidden",
	"scroll",
	"auto",
	"clip",
	"visible"
], l = [
	"leave",
	"scroll",
	"move",
	"never"
];
//#endregion
export { e as DT_BOX_AS_VALUES, r as DT_BOX_BORDER_COLOR_VALUES, a as DT_BOX_BORDER_RADIUS_VALUES, i as DT_BOX_BORDER_WIDTH_VALUES, s as DT_BOX_LAYOUT_VALUES, c as DT_BOX_OVERFLOW_VALUES, l as DT_BOX_SCROLLBAR_VALUES, o as DT_BOX_SHADOW_VALUES, t as DT_BOX_SPACING_VALUES, n as DT_BOX_SURFACE_VALUES };

//# sourceMappingURL=box-constants.js.map